export default "__VITE_ASSET__Dd5K6FF8__"